import { pages, app } from '@microsoft/teams-js'
import config from '@/config'
import PresentationApi from '@/api/presentation'
import cookie from '@/services/cookie'
import utils from '@/util.js'

const SHARING_GUIDE_POPUP_KEY = 'ms-teams-should-show-sharing-guide'
const MAX_COUNT_SHOW_SHARING_GUIDE_POPUP = 5
const encodeEntityId = (presentation) => {
  if (!presentation) return null
  return window.btoa(JSON.stringify(presentation))
}

const decodeEntityId = (str) => {
  if (!str) return null

  const jsonStr = window.atob(str)
  return JSON.parse(jsonStr)
}

const setPresentContext = async (presentation) => {
  localStorage.setItem(SHARING_GUIDE_POPUP_KEY, true)

  const ctx = await app.getContext()
  let presentContext = ''
  if (ctx.channel && ctx.channel.id) {
    presentContext = 'channel'
  } else if (ctx.meeting && ctx.meeting.id) {
    presentContext = 'meeting'
  }
  const frameContext = app.getFrameContext()
  const presentationConfig = {
    id: presentation.id,
    uniqueAccessCode: presentation.uniqueAccessCode,
    shareCode: presentation.shareCode,
    msTeamsUserId: ctx.user.id,
    ahaslidesUserId: presentation.User.id,
  }
  const entityId = encodeEntityId(presentationConfig)
  const contentUrl = `${config.presenterDomain}/ms-teams/presenting/${presentation.id}?context=${presentContext}&entityId=${entityId}`
  if (frameContext === 'settings') {
    await pages.config.setConfig({
      entityId,
      suggestedDisplayName: 'AhaSlides',
      contentUrl,
      websiteUrl: 'https://ahaslides.com',
    })
  } else if (frameContext === 'content') {
    pages.navigateCrossDomain(contentUrl)
  }
}

const reloadPresentingScreen = async (editor) => {
  if (!editor || !editor.currentUser || !editor.presentation) return
  // If the presentation is taken over by other presenter
  // -> need to take over first before reloading
  editor.isReloadingMSTeams = true
  if (editor.currentUser.id !== editor.presentation.takenOverBy) {
    await PresentationApi.takeOver(editor.presentation.id)
  } else {
    await editor.getDataPresentationDetail()
  }
  editor.isReloadingMSTeams = false
  editor.isShowMSTeamsReloadModal = false
}

const checkMSTeamsAuth = (editor) => {
  if (!editor) return
  if (!editor.$store.state.isMSTeamsApp) return
  setInterval(() => {
    const token = cookie.getValue('ahaToken')
    if (!token) {
      editor.$router.replace({
        name: 'MSTeams-Presenting',
        params: { presentationId: editor.presentation.id },
        query: {
          entityId: encodeEntityId(editor.presentation),
        },
      })
    }
  }, 3000)
}

const checkToShowSharingGuidePopup = (editor) => {
  if (!editor || !editor.isMSTeamsApp) return
  const presentContext = utils.getParamValue('context', window.location.href)
  const shouldShowSharingGuidePopup = localStorage.getItem(
    SHARING_GUIDE_POPUP_KEY,
  )
  const countShowSharingGuidePopup = Number(
    localStorage.getItem('countShowSharingGuidePopup') || 0,
  )
  if (
    shouldShowSharingGuidePopup &&
    presentContext === 'meeting' &&
    countShowSharingGuidePopup < MAX_COUNT_SHOW_SHARING_GUIDE_POPUP
  ) {
    editor.showMSTeamsSharingGuidePopup = true

    localStorage.setItem(
      'countShowSharingGuidePopup',
      countShowSharingGuidePopup + 1,
    )
    localStorage.removeItem(SHARING_GUIDE_POPUP_KEY)
  }
}

const initialize = (editor) => {
  if (!editor || !editor.isMSTeamsApp) return
  checkMSTeamsAuth(editor)
  checkToShowSharingGuidePopup(editor)
}
const copyTextWhenAppIsMSTeams = (dom) => {
  const selection = window.getSelection()
  const range = document.createRange()
  range.selectNodeContents(dom)
  selection.removeAllRanges()
  selection.addRange(range)
  document.execCommand('copy')
}
const isDarkThemeInMsTeams = async () => {
  try {
    const ctx = await app.getContext()

    return ctx.meeting && ctx.meeting.id && ctx.app && ctx.app.theme === 'dark'
  } catch (e) {
    return false
  }
}

export default {
  encodeEntityId,
  decodeEntityId,
  setPresentContext,
  reloadPresentingScreen,
  initialize,
  copyTextWhenAppIsMSTeams,
  isDarkThemeInMsTeams,
}
